import './room.css'
import { Avatar, Button, Chip, Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material'
import { useReducer, useState } from 'react';
import HeroSlider from 'hero-slider/dist/HeroSlider';
import { SideNav, Slide } from 'hero-slider';
import target from '../../db/target';
import SelectModal from '../SelectablePackage/SelectModal';

const chipStyle = {
    padding: '0 5px',
    margin: '5px'
}


const ImageSlider = ({ images }) => {

    const endPoint = target + 'images/rooms/'


    return <HeroSlider
        height={''}
        autoplay
        controller={{
            initialSlide: 1,
            slidingDuration: 200,
            slidingDelay: 50,
        }}
        style={{

        }}
    >
        {
            images.map((image, index) => {
                return <Slide key={index} shouldRenderMask label='room image' background={{ backgroundImageSrc: endPoint + image }} />
            })
        }


        <SideNav
            isPositionedRight={false}
            position={{
                top: '50%',
                left: '0%',
                transform: 'translateY(-50%)'
            }}
        />
    </HeroSlider>
}

const reducerPrice = (state, action) => {
    if (action.type === 'price') {
        return action.price
    } else {
        return state
    }
}


export const Room = ({ room = [], setCart, packages = [], available }) => {



    const packageSelect = packages

    const { code, title, description, images, facilities } = room;
    const _title = title

    // console.log(facilities);

    const [expandSelectable, setExpandSelectable] = useState(false);
    const [price, setPrice] = useReducer(reducerPrice, packageSelect.length > 0 ? packageSelect[0].price : 0)
    const [selectedValue, setSelectedValue] = useState('Room Only');

    const endPoint = target + 'images/icons/'

    const handlePackageSelect = (event) => {


        let _price = 0;

        console.log(packageSelect);
        

        if (selectedValue === event.target.value) {
            setSelectedValue('Room Only')
            _price = packageSelect[0].price
        } else {
            setSelectedValue(event.target.value)
            packageSelect.map(pkg => {
                if (pkg.title === event.target.value) {
                    _price = pkg.price
                }
            })
        }

        setPrice({
            type: 'price',
            price: _price
        })

    }

    const handelAddToCart = () => {
        setCart({
          type: 'select',
          code: code,
          packageTitle: selectedValue,
          title: title,
          price
        })
    }

    return (
        <div className="room-box">
            <div className="image-box">
                {/* <img src={image} width={'100%'} /> */}
                <ImageSlider images={images} />
            </div>

            <div className="room-details-box">
                <div className="room-title-box">
                    <p className="room-title">{title}</p>
                    <p className="room-description" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{description}</p>
                </div>
            </div>

            <div className="room-facilities-box">
                {facilities.map(({ iconUrl, title }, index) => {
                    return <Chip key={index} sx={chipStyle} label={title} avatar={<Avatar alt="avatar" src={endPoint + iconUrl} />} />
                })}
            </div>

            <div className="room-select-box">
                <h4>Room options</h4>
                <RadioGroup>
                    {packageSelect.map(({ title, description, price }, index) => {
                        if (title === "Room Only") { return }
                        // return <FormControlLabel key={title} control={< Checkbox onChange={checkboxHandler} value={price} name={title} />} label={title} />
                        return <div key={title} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                <Radio
                                    checked={selectedValue === title}
                                    onClick={handlePackageSelect}
                                    value={title}
                                    name="radio-buttons"
                                />
                                <p>{title}</p>
                            </div>
                            <p style={{ fontWeight: 'bold' }}> + US ${price - packageSelect[0].price}</p>
                        </div>
                    })}
                </RadioGroup>
            </div>

            <div className="room-selectable">
                <div className="selected-price-box">
                    <p className="selected-price notranslate">US ${price}</p>
                    <p className="selected-price-details">two person/ pernight</p>
                </div>
                <SelectModal handler={handelAddToCart} available={available} />
            </div>
        </div>
    )
}